export const UPDATE_SETTINGS = "settings/UPDATE_SETTINGS"

export const updateSettings = data => ({
   type: UPDATE_SETTINGS,
   payload: data
})